<template lang="pug">
v-app
  v-app-bar(app dense dark color="deep-purple accent-4")
    v-app-bar-nav-icon(@click.stop="drawer = !drawer")
    span.ellipse.mr-header(v-if="hasUnreadMessage")
    v-btn.mr-5(v-if="appBackLink" fab small text outlined :to="appBackLink")
      v-icon mdi-keyboard-backspace
    v-toolbar-title
      template(v-if="appBarTitle == 'loading'")
        v-progress-linear(indeterminate style="width:200px;")
      template(v-else) {{ appBarTitle }}

  v-navigation-drawer(v-model="drawer" absolute temporary)
    v-list(nav dense)
      v-list-item-group(v-model="group" active-class="deep-purple--text text--accent-4")
        v-list-item(v-for="(item,index) in menuItems" :key="index" :to="item.path")
          v-list-item-icon
            v-icon {{ item.icon }}
          v-list-item-content
            v-list-item-title(v-text="item.name")
          span.ellipse.mr-nav(v-if="item.name == 'Комментарии' && hasUnreadMessage")
        v-list-item(@click="exit()")
          v-list-item-icon
            v-icon mdi-logout
          v-list-item-content
            v-list-item-title Выход

  

  v-main(app)
    router-view
        
</template>



<script>
import { NavItems as items } from './nav/NavItems'
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    drawer:false,
    group: null
  }),

  mounted() {
    if(!this.isCustomer) this.checkUnreadMessage()
  },

  computed: {
    ...mapState(['appBarTitle','appBackLink']),
    ...mapGetters('authentication', ['checkRole']),
    ...mapState('dialogMessage', ['hasUnreadMessage']),

    isCustomer() {
      return this.checkRole(0)
    },

    menuItems () {
      if(this.isCustomer) return items.filter(el => el.name != "Комментарии")
      return items
    }
  },

  methods: {
    ...mapActions("authentication", ["logout"]),
    ...mapActions('dialogMessage', ['checkUnreadMessage']),
    exit(){
      this.logout() 
    }
  }
}
</script>
<style scoped>
.ellipse {
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background-color: #ED0E51;
  position: relative;
  background-image: url(/src/layouts/img/red-circle.gif);
  background-size: cover;
}
.mr-header {
  margin-left: -10px;
  margin-right: 10px;
  margin-bottom: 17px;
}
</style>


